import { Component, OnInit } from '@angular/core';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';
import { PositionKeepingAnalysis } from 'src/app/models/analysis/position-keeping-analysis.model';
import { TableUtil } from 'src/app/utils';
import { MatTabChangeEvent } from '@angular/material/tabs';

@Component({
  selector: 'app-position-keeping-rebalancing',
  templateUrl: './position-keeping-rebalancing.component.html',
  styleUrls: ['./position-keeping-rebalancing.component.scss']
})
export class PositionKeepingRebalancingComponent implements OnInit {

  inceptionDate: Date;
  investmentDate: Date;
  lastDate: Date;

  currentInvestable: CurrentPortfolio;
  currentInvestableSubscription: Subscription;

  selectedRebalanceTab: string ='exposure';
  rebalancingTab: string = 'factorExposure';

  investablePKA: PositionKeepingAnalysis;
  investableRA;
  is_standalone: boolean = false;
  is_protected: boolean = true;

  quarterly_dates: string[];

  rebalanceYes: boolean = true;
  rebalanceNo: boolean = false;
  nextRebalancingDate: Date;

  completenessLabels: string[];
  completenessNames: string[];
  isStandalone: boolean = true;

  constructor(private clustersService: ClustersService) { }

  ngOnInit(): void {
    this.subscribeToCurrentInvestable();
  }

  ngOnDestroy() {
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        if (investable_portfolio!=undefined) {
          this.inceptionDate = investable_portfolio.positionKeepingAnalysis.inception_date;
          this.investmentDate = investable_portfolio.positionKeepingAnalysis.investment_date;
          this.lastDate = investable_portfolio.positionKeepingAnalysis.last_date;
          this.investablePKA = investable_portfolio.positionKeepingAnalysis;

          this.isStandalone = this.investablePKA.is_standalone;

          this.quarterly_dates = Object.keys(this.investablePKA.rebalancing.quarterly_exposure.size);
          this.completenessLabels = Object.keys(this.investablePKA.rebalancing.cpl_funds_names);
          this.completenessNames = this.investablePKA.rebalancing.cpl_funds_names;
          this.rebalanceYes = this.investablePKA.parameters.next_rbl.flag;
          this.rebalanceNo = !this.rebalanceYes;
          this.nextRebalancingDate = new Date(this.investablePKA.parameters.next_rbl.date);

          this.investableRA = this.investablePKA.rebalancing;
        }
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

  onRebalancingTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Exposure':        this.rebalancingTab='factorExposure'; break;
      case 'Spread':          this.rebalancingTab='factorMonitoring'; break;
    }
  }

  checkRebalanceYes() {
    if (this.rebalanceYes) {
      this.rebalanceNo = false;
    }else{
      this.rebalanceNo = true;
    }
  }

  checkRebalanceNo() {
    if (this.rebalanceNo) {
      this.rebalanceYes = false;
    }else{
      this.rebalanceYes = true;
    }
  }

  onRebalance() {

  }

  onDoNotRebalance() {

  }

}
